export default "__VITE_ASSET__DB0NL8dc__"